import { PaginationProgressProps } from './types';
import styles from './Pagination.module.scss';

export const PaginationProgress = ({ progress = 0, label }: PaginationProgressProps) => {
	return (
		<div className={styles.paginationProgressContainer}>
			<p className={styles.paginationProgress__label}>{label}</p>
			<div className={styles.paginationProgress__bar}>
				<div
					className={styles.paginationProgress__bar__progress}
					style={{ width: `${progress}%` }}
				/>
			</div>
		</div>
	);
};
